var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authResultBody"},[(_vm.code == '1')?_c('div',{staticClass:"authResultMain"},[_c('img',{attrs:{"src":require("@/assets/image/success.png")}}),_c('h2',[_vm._v("刷脸完成")])]):_c('div',{staticClass:"authResultMain"},[_c('img',{attrs:{"src":require("@/assets/image/fail.png")}}),_c('h2',[_vm._v("刷脸失败")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }